import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsProps } from 'antd';
import { BreadcrumbItem } from '@celebration/react/ClbBreadcrumb/ClbBreadcrumb.types';
import Subheader from '../../common/components/subheader';
import ReportsConstants from './constants';
import ReportsFilters from './components/reports-filters';
import './reports.scss';
import HomeConstants from '../home/constants';
import ReportsHistoric from './components/reports-historic/reports-historic';

export default function Reports() {
    const { t } = useTranslation();
    const breadcrumbList: BreadcrumbItem[] = [
        { label: HomeConstants.PAGE_TITLE, url: HomeConstants.PATH },
        { label: t(ReportsConstants.PAGE_TITLE), url: ReportsConstants.PATH },
    ];

    const [isGeneratingReport, setIsGeneratingReport] = useState(false);

    const tabsItems: TabsProps['items'] = [
        {
            key: '0',
            label: t('Historico'),
            children: (
                <ReportsHistoric isGeneratingReport={isGeneratingReport} />
            ),
        },
    ];

    return (
        <>
            <Subheader
                title={t(ReportsConstants.PAGE_TITLE)}
                breadcrumbList={breadcrumbList}
                dataTestid="reports-subheader"
            />

            <ReportsFilters
                isGeneratingReport={isGeneratingReport}
                setIsGeneratingReport={setIsGeneratingReport}
            />

            <Tabs className="reports-tabs" items={tabsItems} />
        </>
    );
}
